module.exports = __webpack_public_path__ + "img/105.caa94ec5.png";